import {
  AccountBalance,
  AccountBalanceChart,
  AccountDailyPerformance,
  AccountsForRunningContestsResponse,
  AccountStats,
  ContestAccountArchiveType,
  ContestAccountType,
} from '@monorepo/types';
import BaseEntityService, { BaseResponse } from '../core/base-entity-service';

export default class ContestAccountService extends BaseEntityService {
  static override route = 'contest-account';

  async getContestAccount(tsAccountId: string) {
    try {
      const response = await this.httpService.get<
        BaseResponse<ContestAccountType>
      >(`${this.path}/ts/${tsAccountId}`);

      return response.data;
    } catch (e) {
      console.error(`Failed getting user's contest account`, e);
      throw e;
    }
  }

  async getAccountArchive(tsAccountId: string) {
    try {
      const response = await this.httpService.get<
        BaseResponse<ContestAccountArchiveType>
      >(`${this.path}/${tsAccountId}/archive`);

      return response.data;
    } catch (e) {
      console.error(`Failed getting account balance chart: ${tsAccountId}`, e);
      throw e;
    }
  }

  async getBalanceChart(tsAccountId: string) {
    try {
      const response = await this.httpService.get<
        BaseResponse<AccountBalanceChart[]>
      >(`${this.path}/${tsAccountId}/balance-chart`);

      return response.data;
    } catch (e) {
      console.error(`Failed getting account balance chart: ${tsAccountId}`, e);
      throw e;
    }
  }

  async getBalance(tsAccountId: string) {
    try {
      const response = await this.httpService.get<BaseResponse<AccountBalance>>(
        `${this.path}/${tsAccountId}/balance`,
      );

      return response.data;
    } catch (e) {
      console.error(`Failed getting account balance: ${tsAccountId}`, e);
      throw e;
    }
  }

  async getDailyPerformance(tsAccountId: string) {
    try {
      const response = await this.httpService.get<
        BaseResponse<AccountDailyPerformance>
      >(`${this.path}/${tsAccountId}/daily-performance`);

      return response.data;
    } catch (e) {
      console.error(`Failed getting daily performance: ${tsAccountId}`, e);
      throw e;
    }
  }

  async getStats(tsAccountId: string) {
    try {
      const response = await this.httpService.get<BaseResponse<AccountStats>>(
        `${this.path}/${tsAccountId}/stats`,
      );

      return response.data;
    } catch (e) {
      console.error(`Failed getting account stats: ${tsAccountId}`, e);
      throw e;
    }
  }

  async getCredentials(tsAccountId: string) {
    try {
      const response = await this.httpService.get<
        BaseResponse<{
          login: string;
          password: string;
        }>
      >(`${this.path}/${tsAccountId}/credentials`);

      return response.data;
    } catch (e) {
      console.error(`Failed getting account credentials: ${tsAccountId}`, e);
      throw new Error('Failed decrypting password');
    }
  }

  async getAccountsForRunningContests() {
    try {
      const response = await this.httpService.get<
        BaseResponse<AccountsForRunningContestsResponse>
      >(`${this.path}/category`);

      return response.data;
    } catch (e) {
      console.error(`Failed getting accounts for running contests`, e);
      throw e;
    }
  }
}
